module.exports = __webpack_public_path__ + "img/icon_mall_arr_prev_on.e62e4381.svg";